module.exports = __webpack_public_path__ + "img/autorization.20b2ffa3.png";